module.exports = __webpack_public_path__ + "img/6.6db05b9e.png";